import { GridCol, GridRow, mixins, styled } from '@bob/library'
import { SpotLinkAnchor } from '@websrc/Spot/Link/SpotLinkAnchor'

export const StyledNavGridCol = styled(GridCol)`
  border-right: 1px solid ${mixins.colors.grayLowlight};
`
export const StyledContentGridCol = styled(GridCol)`
  background: ${mixins.colors.grayLight};
  ${mixins.padding(10)}

  ${mixins.media.min.phone} {
    ${mixins.padding(30)};
  }
`
export const StyledContentGridRow = styled(GridRow)`
  border: 1px solid ${mixins.colors.grayLowlight};
`
export const StyledHR = styled.hr`
  border: 1px solid ${mixins.colors.grayLowlight};
  ${mixins.margin(50, 0)}
`
export const ButtonTertiary = styled.button`
  ${mixins.cta.tertiary('blue')}
`

export const StyledCTA = styled(SpotLinkAnchor)`
  ${mixins.margin.top(20)}
`
